export default "__VITE_ASSET__1600ad36__"